// cardLabel: short wording on search result cards (Phase 2 mockup, "Good condition").
export const productConditions = [
    { option: 'brandNew', label: "Brand new", cardLabel: "Brand new", info: "Unused with original packaging or tags" },
    { option: 'likeNew', label: "Like new", cardLabel: "Like new", info: "Mint condition pre-owned or new without tags" },
    { option: 'usedExcellent', label: "Used - Excellent", cardLabel: "Excellent condition", info: "Lightly used but no noticeable flaws" },
    { option: 'usedGood', label: "Used - Good", cardLabel: "Good condition", info: "Minor flaws or signs of wear, to be noted in the description or photos" },
    { option: 'usedFair', label: "Used - Fair", cardLabel: "Fair condition", info: "Obvious flaws or signs of wear, to be noted in the description or photos" },
]

export const getConditionCardLabel = option =>
    productConditions.find(c => c.option === option)?.cardLabel || null;
